// client/src/utils/profileVisibility.generated.js
//
// GENERATED - do not edit by hand.
//
// Copied from packages/core/src/ui/visibility.js by tools/sync-shared.py. Edit the core file and re-run that
// script; `node tools/marks-sheet-conformance.mjs` asserts this copy has not
// drifted from it.
//
// The phone imports the original. The web cannot (packages/core is outside
// client/src, and the CRA build will not resolve it), so it gets this. They must
// stay identical - a rule that exists twice and differs is the whole class of
// bug these files were written to end.
//
// Whether a profile shows its own evaluations. Both clients held the same
// three-role list and the same bug in it, which is what a rule written
// twice always comes to.

/**
 * DOES THIS PERSON HAVE EVALUATIONS OF THEIR OWN?
 *
 * The staff evaluation programme rates the people who teach. Some roles are not
 * in it, and for them a card headed "My evaluations" only ever renders "You are
 * not currently enrolled in the staff evaluation programme" — a sentence about
 * something that was never theirs, on their own profile, every time they open it.
 * Hiding the card says the same thing better by saying nothing.
 *
 * WHO IS OUT, and why each:
 *
 *   student, parent   never staff.
 *   system admin      not a member of any school's staff.
 *   school admin,
 *   principal,
 *   headmaster        they RUN the evaluations. Being the assessor and being
 *                     absent from the list of the assessed is the same fact.
 *
 * NON-ALPHANUMERICS ARE STRIPPED FIRST, and that is not cosmetic. Both clients
 * matched a lowercased role name against 'systemadmin' — so "System Admin", with
 * its space, never matched and system admins were shown the very card this test
 * existed to hide from them. Role names are typed by people and arrive as
 * "School Admin", "Principal/Headmaster", "Head Teacher"; comparing them without
 * normalising is comparing typography.
 *
 * `includes` rather than equality, deliberately: a school may call the role
 * "Deputy Principal" or "Principal (Head Teacher)", and both are the same job
 * for this purpose.
 *
 * @param {string} roleName
 * @returns {boolean}
 */
export function showsOwnEvaluations(roleName) {
  const rn = String(roleName || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  if (!rn) return false;

  const NOT_EVALUATED = [
    'student', 'parent', 'systemadmin',
    'schooladmin', 'principal', 'headmaster', 'headteacher',
  ];
  return !NOT_EVALUATED.some((r) => rn.includes(r));
}
